<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper cart-wrapper">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <div class="nav-bar-wrapper">
            <div class="nab-bar-left">
              <button @click="goBack()" class="button is-flex nav-back">
                <img src="@/assets/img/icon-card.svg" alt="Go Back" />
              </button>
              <h1 class="has-text-black">Success</h1>
            </div>
          </div>
        </div>
      </app-header>

      <!-- If no cart item -->
      <main class="content-wrapper has-text-grey has-text-centered pt20 mb100">
        <div class="container">
          <div class="columns is-multiline">
              <div class="column is-12-widescreen is-12-desktop is-12-tablet is-12-mobile">
                <img src="@/assets/img/icon-basket.svg" alt="image" />
                <p class="is-size-15 mt50">Thank you {{ userFullName }} for your order. Your order number is {{ $route.query.order_id }} and will be prepared shortly.</p>
                <p v-if="kioskMode" class="is-size-2">{{ successCounter }}</p>
             </div>
             <template v-if="!kioskMode">
              <div v-if="$store.getters.getLoggedInUserToken" class="column is-6-widescreen is-6-desktop is-12-tablet is-12-mobile">
                <button
                  class="button mb-3 is-large bg-primary text-white hover-opacity-7 is-full-width"
                  @click.prevent="showOrderStatus()"
                >View Order Status</button>
              </div>
              <div :class="$store.getters.getLoggedInUserToken ? 'column is-6-widescreen is-6-desktop is-12-tablet is-12-mobile' : 'column'">
                <button
                  class="button is-large bg-secondary text-white hover-opacity-7 is-full-width"
                  @click.prevent="continueShopping()"
                >Continue Shopping</button>
              </div>
              
            </template>
          </div>
        </div>
        <div class="overlay-page" v-if="countdownOverlay"></div>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import CartApis from '@/Components/Controllers/CartApis';
import LocaitonApis from '@/Components/Controllers/LocationApis';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import * as _ from 'lodash';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  components: {
  },
  name: 'CartSuccess',
  data() {
    return {
      successCounter: 0,
      timer: null,
      countdownOverlay:  false,
    };
  },

  computed: {
    ...mapGetters({
      vg_cartSuccessObj: "cart/successObj",
      vg_selectedStore: "location/selected",
    }),
    kioskMode() {
       return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },
    userFullName() {
      if(this.$store.getters.getLoggedInUserToken){
        return (
          this.$store.getters.getLoggedInUser.first_name +
          " " +
          this.$store.getters.getLoggedInUser.last_name
        );
      }
      return '';
    },
  },

  mounted() {
    if(_.isEmpty(this.vg_cartSuccessObj)){
      return this.$router.push({ 
        name: 'StoreProfile', 
        params: {
          store_slug: this.$route.params.store_slug,
          business_slug: this.$route.params.business_slug,
        },
        query: this.$route.query,
      })
    }
    
    // If kiosk Mode, count upto 10 then if user is logged in logout user
    if(this.kioskMode) {
      //  block the router
      this.successCounter = 10;
      this.countdownOverlay  =  true;
      this.timer = setInterval(() => {
        this.successCounter = (this.successCounter - 1)
        if(this.successCounter == 0){
          clearInterval(this.timer);
          this.signOutIfLoggedIn();
        }
      }, 1000)
    }
    
  },

  unmounted() {
    clearInterval(this.timer);
  },
  methods:{
    /**
     * logout user + send them to shop page
     */
    async signOutIfLoggedIn() {
      // If user logged in clear him
      if(this.$store.getters.getLoggedInUserId){
        this.va_setUserLoyalityObj({});
        let channels = [];
        channels.push('user-' + this.$store.getters.getLoggedInUserId + '-location-' + this.vg_selectedStore.id);
        channels.push(this.$store.getters.getLoggedInUserId + '-user');
        if(this.vg_selectedStore.id){
          channels.push(this.vg_selectedStore.id + '-user');
        }
        channels.push('user-' + this.$store.getters.getLoggedInUserId + '-notifications');
        if(window.pubnub){
          window.pubnub.unsubscribe({
              channels: channels,
          });
          var existingListener = {
            message: function () {
            },
          };
          window.pubnub.removeListener(existingListener);
          window.pubnub.unsubscribeAll();
        }
        
        // remove local data either lout out fail or true
        await UserApis.logout();
        // remove Fb cache if any
        if(window.FB != undefined){
          window.FB.getLoginStatus((fbloginRes) =>{
            if(fbloginRes.status == 'connected'){
              window.FB.logout(function(){
                console.log('fb out.')
              });
            }
          })
        }
      }

      // Now we dont need to send on home page rather send to location page
      this.va_clearCart();
      this.$store.dispatch('REMOVE_APP_DATA', '');
      this.$router.push({ 
        name: 'StoreLanding', 
        params: { 
          business_slug: this.$route.params.business_slug,  
          store_slug: this.$route.params.store_slug, 
        },
        query: Helpers.refineQuery(['order_id'],this.$route.query)
      }) 
     
    },
    /**
     * Push to order status
     */
    showOrderStatus() {
      // tab must be upcoming 
      this.va_setActiveTab('coming');
      this.va_setCurrentOrder(this.vg_cartSuccessObj);
      this.$router.push({
        name: 'UserOrderStatus',
        query: Helpers.refineQuery(['order_id'],this.$route.query)
      })
    },

    continueShopping() {
      this.$router.push({
        name: 'StoreProfile',
        params: {
          store_slug: this.$route.params.store_slug,
        },
        query: Helpers.refineQuery(['order_id'],this.$route.query)
      })
    },
  
    ...mapActions({
      va_setCurrentOrder: "orderhistory/setCurrentOrder",
      va_setActiveTab: "orderhistory/setActiveTab",
      va_clearCart: "cart/clearCart",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })

  },
};
</script>
<style scoped>
.text-sm {
  font-size: 13px;
}
.nab-bar-left {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.nav-bar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 100%; */
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}
.overlay-page {
    background: #fff0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
}
</style>
